import React from 'react';

/**
 * Error state for the users list with a retry affordance.
 * Props: { message, onRetry }
 */
const ErrorState = ({ message, onRetry }) => (
  <div className="uv-state" data-testid="users-error">
    <div className="uv-state__icon" aria-hidden="true">⚠️</div>
    <p className="uv-state__title">Couldn’t load users</p>
    <p className="uv-state__msg">{message || 'Something went wrong while loading the list.'}</p>
    {onRetry ? (
      <button type="button" className="uv-state__btn" onClick={onRetry}>Retry</button>
    ) : null}
  </div>
);

export default ErrorState;
